/**
 * Get is tour shown for the first time
 *
 * @param {string} tourID - tour ID
 * */

export const getIsTourShownFirstTime = (tourID) => {
    // TODO: fetch value from the server
    return !(localStorage.getItem(tourID));
};